import { Component } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { scrollIntoView } from 'util/index';

interface ScrollToTopProps extends RouteComponentProps {
  children?: React.ReactNode;
}

interface LocationState {
  scrollTo?: string;
  skipScrollToTop?: boolean;
}

class ScrollToTop extends Component<ScrollToTopProps> {
  componentDidUpdate(prevProps: ScrollToTopProps) {
    const locationState = this.props.location.state as LocationState;
    const prevLocationState = prevProps.location.state as LocationState;
    
    if (locationState?.scrollTo) {
      scrollIntoView(null, locationState.scrollTo, {});
      return;
    }
    if (locationState?.skipScrollToTop) {
      return;
    }
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }
  
  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);
